export default __webpack_public_path__ + "static/media/bo_6.7ee0695b.mp3";